import { createLogger } from '@wtc/logger';

/**
 * Package-scoped logger for @wtc/meridian. Import this in handlers/lib
 * modules rather than calling `createLogger` directly so the `service`
 * binding stays consistent across the package.
 *
 * Per-request scoping: derive a child logger with bindings:
 *   const reqLogger = logger.child({ requestId, chatId, userId });
 */
export const logger = createLogger({ service: '@wtc/meridian' });

export type { Logger } from '@wtc/logger';
